import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "grid h-[24px] w-[24px] place-items-center rounded-full bg-gray-600 text-xs text-white text-xs-bold" }
const _hoisted_4 = ["innerHTML"]

import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { IHighlight } from '@/interfaces/forms/highlights-interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Highlights',
  props: {
    showNumber: { type: Boolean },
    highlightsTitle: {},
    highlights: {}
  },
  setup(__props: any) {

const props = __props;

const isLastItem = (itemIndex: number) => {
  return itemIndex + 1 === props.highlights.length;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionPanel, {
    title: { value: _ctx.highlightsTitle }
  }, {
    sectionPanelContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: _normalizeClass([{
            'border-b border-racq-white': itemIndex + 1 < props.highlights.length,
          }, "flex gap-4"])
          }, [
            (_ctx.showNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(itemIndex + 1), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["text-m text-racq-dark-grey", [!isLastItem(itemIndex) ? 'pb-4' : '', _ctx.showNumber ? 'pl-4 md:pl-0' : '']]),
              innerHTML: item.content
            }, null, 10, _hoisted_4)
          ], 2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})